module.exports = __webpack_public_path__ + "static/img/default_headerimg.5ca243c3.png";